import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PATHS: any = ['/app/administracion/usuarios', '/app/administracion/roles'];

function useAdmin() {
    const { pathname } = useLocation();
    const navigate = useNavigate();
    const pathIndex = useMemo(() => PATHS.findIndex((p: any) => pathname === p), [pathname]);
    const [tabValue, setTabValue] = React.useState(pathIndex < 0 ? 0 : pathIndex);

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        navigate(`${PATHS[newValue]}`, { replace: true });
        setTabValue(newValue);
    };

    useEffect(() => {
        if (!PATHS?.find((p: any) => pathname === p)) {
            navigate('/app/administracion/usuarios', { replace: true });
        }
        // eslint-disable-next-line
    }, []);

    return { tabValue, handleChangeTab };
}

export default useAdmin;
